var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-option',{key:_vm.source.uid,attrs:{"value":(_vm.source.type =='1' || _vm.source.type == '2') ? _vm.source.name : _vm.source.id,"label":_vm.source.name}})
}
var staticRenderFns = []

export { render, staticRenderFns }